<template>
    <v-container fluid>
        <v-card class="card-container">
            <v-form ref="filterTransactionForm" lazy-validation>
                <v-card-title class="pa-0 mb-5">
                    <v-row no-gutters class="standard-row header-container" align="center">
                        <h3 class="header-text">
                            รวมเอกสาร
                        </h3>
                        <v-tooltip top :disabled="!filterData.topic.value && true">
                            <template v-slot:activator="{ on, attrs }">
                                <v-select
                                    outlined
                                    hide-details
                                    v-on="on"
                                    v-bind="attrs"
                                    :menu-props="{ bottom: true, offsetY: true }"
                                    placeholder="Looking For"
                                    :items="itemSearchDropdown"
                                    height="26"
                                    ref="searchDropdown"
                                    color="#000"
                                    item-color="#D9D9D9"
                                    append-icon="mdi-chevron-down"
                                    class="search-input-dropdown"
                                    v-model="filterData.topic"
                                    return-object
                                    @change="!filterData.topic?.value && clearFilterData()"
                                    :rules="[ v => !!v && !!v.value ]"
                                    required
                                >
                                    <template v-slot:item="data">
                                        <v-list-item-content>
                                            <v-list-item-title class="list-item-dropdown">
                                                {{ data.item.text }}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </template>
                                </v-select>
                            </template>
                            <span class="font-theme">{{ filterData.topic?.text || '' }}</span>
                        </v-tooltip>
                        <v-text-field
                            placeholder="Search"
                            outlined
                            rounded
                            hide-details
                            height="26"
                            color="#000"
                            append-icon="mdi-magnify"
                            class="search-input-text"
                            v-model="filterData.holdKeyword"
                            :rules="[ v => !!v ]"
                            required
                            @click:append="confirmFilterData()"
                            @keyup.enter="confirmFilterData()"
                        ></v-text-field>
                        <v-btn
                            rounded
                            depressed
                            color="#0B68D6"
                            class="white--text download-button"
                            height="40"
                            width="140"
                            @click="goToDownloadReport()"
                        >
                            Download
                        </v-btn>
                    </v-row>
                </v-card-title>
                <v-row no-gutters class="standard-row">
                    <v-data-table
                        fixed-header
                        dense
                        disable-sort
                        :headers="tableHeaders"
                        :items="itemsDataTable"
                        :server-items-length="countTransaction"
                        class="data-table"
                        :options.sync="optionsTransaction"
                        mobile-breakpoint="600"
                        :loading="(callApiPending > 0 && $vuetify.breakpoint.smAndUp) && true"
                        :footer-props="{ 'items-per-page-options': [20, 30, 40, 50], 'items-per-page-text': 'จำนวนแถวต่อหน้า' }"
                    >
                        <template v-slot:body="{ items, isMobile }">
                            <tbody v-if="items.length && !isMobile">
                                <tr v-for="(body, indexBody) in items" :key="indexBody" class="get-element-tr">
                                    <td valign="top" align="center">
                                        <v-row
                                            no-gutters
                                            class="text-center standard-row each-header-row-expand-table"
                                            justify="center"
                                            align="center"
                                        >
                                            {{ body.number }}
                                        </v-row>
                                    </td>
                                    <td valign="top" align="center">
                                        <v-row
                                            no-gutters
                                            class="text-center standard-row each-header-row-expand-table"
                                            justify="center"
                                            align="center"
                                        >
                                            {{ body.po }}
                                        </v-row>
                                    </td>
                                    <td valign="top" align="center">
                                        <v-row
                                            no-gutters
                                            class="text-center standard-row each-header-row-expand-table"
                                            justify="center"
                                            align="center"
                                        >
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                        icon
                                                        elevation="0"
                                                        depressed
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        small
                                                        :color="items[indexBody].save_budget? '#1BDE3A' : '#A8A8A8'"
                                                        :disabled="!body.expanded.length"
                                                        @click="openSaveBudget(body)"
                                                    >
                                                        <v-icon>
                                                            mdi-information
                                                        </v-icon>
                                                    </v-btn>
                                                </template>
                                                <span class="font-theme">บันทึกงบ</span>
                                            </v-tooltip>
                                        </v-row>
                                    </td>
                                    <td valign="top" align="center">
                                        <v-expansion-panels class="expansion-cs-list" v-model="body.open_expanded">
                                            <v-expansion-panel>
                                                <v-expansion-panel-header class="pa-0 close-expand-icon">
                                                    <v-row
                                                        class="text-center standard-row each-header-row-expand-table"
                                                        no-gutters
                                                        style="height: auto; line-height: 20px;"
                                                        justify="center"
                                                        align="center"
                                                    >
                                                    <template v-for="(csList, indexCS) in body.expanded">
                                                        {{ csList.sale_document }} <br v-if="indexCS + 1 < body.expanded.length" :key="indexCS">
                                                    </template>
                                                    </v-row>
                                                </v-expansion-panel-header>
                                                <v-expansion-panel-content>
                                                    <template v-for="(itemExpand, indexExpand) in body.expanded">
                                                        <v-row
                                                            v-for="(csList, indexCS) in itemExpand.cs_list"
                                                            :key="`${indexExpand}_${indexCS}`"
                                                            class="text-center standard-row cell-class-expand-table"
                                                            :name="`doc_id_${indexBody}`"
                                                            no-gutters
                                                            justify="center"
                                                        >
                                                            {{ csList.sale_document }}
                                                        </v-row>
                                                    </template>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </td>
                                    <td valign="top">
                                        <v-expansion-panels v-show="body.expanded.length" class="expansion-cs-list" v-model="body.open_expanded">
                                            <v-expansion-panel @click.native="handleExpandDocID(indexBody)">
                                                <v-expansion-panel-header class="pa-0 expand-header-document-id" expand-icon="mdi-menu-down" />
                                                <v-expansion-panel-content>
                                                    <template v-for="(itemExpand, indexExpand) in body.expanded">
                                                        <v-row
                                                            v-for="(csList, indexCS) in itemExpand.cs_list"
                                                            :key="`${indexExpand}_${indexCS}`"
                                                            class="text-center standard-row cell-class-expand-table"
                                                            :name="`doc_id_${indexBody}`"
                                                            no-gutters
                                                            justify="center"
                                                        >
                                                            {{ csList.document_id }}
                                                        </v-row>
                                                    </template>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </td>
                                    <td valign="top">
                                        <v-expansion-panels class="expansion-cs-list" v-model="body.open_expanded">
                                            <v-expansion-panel>
                                                <v-expansion-panel-header class="pa-0 hide-expand-icon" />
                                                <v-expansion-panel-content>
                                                    <template v-for="(itemExpand, indexExpand) in body.expanded">
                                                        <v-row
                                                            v-for="(csList, indexCS) in itemExpand.cs_list"
                                                            :key="`${indexExpand}_${indexCS}`"
                                                            class="text-center standard-row cell-class-expand-table"
                                                            :name="`doc_id_${indexBody}`"
                                                            no-gutters
                                                            justify="center"
                                                        >
                                                            {{ csList.job_status }}
                                                        </v-row>
                                                    </template>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </td>
                                    <td valign="top">
                                        <v-expansion-panels class="expansion-cs-list" v-model="body.open_expanded">
                                            <v-expansion-panel>
                                                <v-expansion-panel-header class="pa-0 hide-expand-icon" />
                                                <v-expansion-panel-content>
                                                    <template v-for="(itemExpand, indexExpand) in body.expanded">
                                                        <v-row
                                                            v-for="(csList, indexCS) in itemExpand.cs_list"
                                                            :key="`${indexExpand}_${indexCS}`"
                                                            class="text-center standard-row cell-class-expand-table"
                                                            :name="`doc_id_${indexBody}`"
                                                            no-gutters
                                                            justify="center"
                                                        >
                                                            {{ csList.group_service }}
                                                        </v-row>
                                                    </template>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </td>
                                    <td valign="top" align="center">
                                        <v-expansion-panels class="expansion-cs-list" v-model="body.open_expanded">
                                            <v-expansion-panel>
                                                <v-expansion-panel-header class="pa-0 hide-expand-icon" />
                                                <v-expansion-panel-content>
                                                    <template v-for="(itemExpand, indexExpand) in body.expanded">
                                                        <v-row
                                                            v-for="(csList, indexCS) in itemExpand.cs_list"
                                                            :key="`${indexExpand}_${indexCS}`"
                                                            class="text-center standard-row cell-class-expand-table"
                                                            :name="`doc_id_${indexBody}`"
                                                            no-gutters
                                                            justify="center"
                                                        >
                                                            {{ csList.service_name }}
                                                        </v-row>
                                                    </template>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </td>
                                    <td valign="top" align="center">
                                        <v-expansion-panels class="expansion-cs-list" v-model="body.open_expanded">
                                            <v-expansion-panel>
                                                <v-expansion-panel-header class="pa-0 hide-expand-icon" />
                                                <v-expansion-panel-content>
                                                    <template v-for="(itemExpand, indexExpand) in body.expanded">
                                                        <v-row
                                                            v-for="(csList, indexCS) in itemExpand.cs_list"
                                                            :key="`${indexExpand}_${indexCS}`"
                                                            class="text-center standard-row cell-class-expand-table"
                                                            :name="`doc_id_${indexBody}`"
                                                            no-gutters
                                                            justify="center"
                                                        >
                                                            {{ csList.qt_vendor }}
                                                        </v-row>
                                                    </template>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </td>
                                    <td valign="top" align="center">
                                        <v-expansion-panels class="expansion-cs-list" v-model="body.open_expanded">
                                            <v-expansion-panel>
                                                <v-expansion-panel-header class="pa-0 hide-expand-icon" />
                                                <v-expansion-panel-content>
                                                    <template v-for="(itemExpand, indexExpand) in body.expanded">
                                                        <v-row
                                                            v-for="(csList, indexCS) in itemExpand.cs_list"
                                                            :key="`${indexExpand}_${indexCS}`"
                                                            class="text-center standard-row cell-class-expand-table"
                                                            :name="`doc_id_${indexBody}`"
                                                            no-gutters
                                                            justify="center"
                                                        >
                                                            {{ csList.qt_value }}
                                                        </v-row>
                                                    </template>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </td>
                                    <td valign="top">
                                        <v-expansion-panels class="expansion-cs-list" v-model="body.open_expanded">
                                            <v-expansion-panel>
                                                <v-expansion-panel-header class="pa-0 hide-expand-icon" />
                                                <v-expansion-panel-content>
                                                    <template v-for="(itemExpand, indexExpand) in body.expanded">
                                                        <v-row
                                                            v-for="(csList, indexCS) in itemExpand.cs_list"
                                                            :key="`${indexExpand}_${indexCS}`"
                                                            class="text-center standard-row cell-class-expand-table"
                                                            :name="`doc_id_${indexBody}`"
                                                            no-gutters
                                                            justify="center"
                                                        >
                                                            {{ csList.products.discount || '0.00' }}
                                                        </v-row>
                                                    </template>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </td>
                                    <td valign="top" align="center">
                                        <v-row
                                            no-gutters
                                            class="text-center standard-row"
                                            justify="center"
                                            align="center"
                                            style="height: 40px;"
                                        >
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn
                                                    v-if="raDetail.account_id == body.account_id"
                                                    icon
                                                    elevation="0"
                                                    depressed
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    small
                                                    color="#808080"
                                                    :disabled="!body.expanded.length"
                                                    @click="openCancelSaveBudgetList(body)"
                                                >
                                                    <v-icon>
                                                        mdi-delete
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span class="font-theme">ลบข้อมูล</span>
                                        </v-tooltip>
                                        </v-row>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else-if="items.length && isMobile">
                                <tr v-for="(_, indexBody) in items" :key="indexBody" class="table-row-mobile">
                                    <v-row no-gutters class="standard-row" justify="space-between" align="center">
                                        <v-col cols="auto" sm="auto" class="pr-1">
                                            No.
                                        </v-col>
                                        <v-col cols="auto" sm="auto" class="pl-1">
                                            {{ items[indexBody].number }}
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters class="standard-row" justify="space-between" align="center">
                                        <v-col cols="auto" sm="auto" class="pr-1">
                                            PO
                                        </v-col>
                                        <v-col cols="auto" sm="auto" class="pl-1">
                                            {{ items[indexBody].po }}
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters class="standard-row" justify="space-between" align="center">
                                        <span>บันทึกงบ</span>
                                        <span>
                                            <v-btn
                                                icon
                                                elevation="0"
                                                depressed
                                                small
                                                :color="items[indexBody].save_budget? '#1BDE3A' : '#A8A8A8'"
                                                :disabled="!items[indexBody].expanded.length"
                                                @click="openSaveBudget(items[indexBody].save_budget)"
                                            >
                                                <v-icon>
                                                    mdi-information
                                                </v-icon>
                                            </v-btn>
                                        </span>
                                    </v-row>
                                    <v-row no-gutters class="standard-row" justify="space-between">
                                        <v-col cols="auto" sm="auto" class="pr-1">
                                            Sale Document
                                        </v-col>
                                        <v-col cols="auto" sm="auto" class="pl-1">
                                            <v-row
                                                no-gutters
                                                class="standard-row"
                                                v-for="(saleDocList, indexExpand) in items[indexBody].expanded"
                                                :key="indexExpand"
                                            >
                                                {{ saleDocList.sale_document }}
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters class="standard-row" justify="space-between" align="center">
                                        <span>ยกเลิกรายการที่บันทึก</span>
                                        <span>
                                            <v-btn
                                                v-if="raDetail.account_id == items[indexBody].account_id"
                                                icon
                                                elevation="0"
                                                depressed
                                                small
                                                color="#808080"
                                                :disabled="!items[indexBody].expanded.length"
                                                @click="openCancelSaveBudgetList(items[indexBody])"
                                            >
                                                <v-icon>
                                                    mdi-delete
                                                </v-icon>
                                            </v-btn>
                                        </span>
                                    </v-row>
                                    <v-row v-if="items[indexBody].expanded.length" no-gutters class="standard-row" justify="space-between" align="center">
                                        <v-expansion-panels class="expand-table-mobile">
                                            <v-expansion-panel>
                                                <v-expansion-panel-header expand-icon="mdi-menu-down">
                                                    Document ID
                                                </v-expansion-panel-header>
                                                <v-expansion-panel-content>
                                                    <v-row
                                                        no-gutters
                                                        class="standard-row"
                                                        v-for="(itemExpand, indexExpand) in items[indexBody].expanded"
                                                        :key="indexExpand"
                                                    >
                                                        <v-row
                                                            no-gutters
                                                            class="standard-row pt-2"
                                                            v-for="(csList, indexCS) in itemExpand.cs_list"
                                                            :key="indexCS"
                                                        >
                                                            <hr style="width:100%;">
                                                            <v-row no-gutters class="standard-row" justify="space-between" align="center">
                                                                <v-col cols="auto" sm="auto" class="pr-1">
                                                                    Sale Document
                                                                </v-col>
                                                                <v-col cols="auto" sm="auto" class="pl-1">
                                                                    {{ csList.sale_document }}
                                                                </v-col>
                                                            </v-row>
                                                            <v-row no-gutters class="standard-row" justify="space-between" align="center">
                                                                <v-col cols="auto" sm="auto" class="pr-1">
                                                                    Document ID
                                                                </v-col>
                                                                <v-col cols="auto" sm="auto" class="pl-1">
                                                                    {{ csList.document_id }}
                                                                </v-col>
                                                            </v-row>
                                                            <v-row no-gutters class="standard-row" justify="space-between" align="center">
                                                                <v-col cols="auto" sm="auto" class="pr-1">
                                                                    Job Status
                                                                </v-col>
                                                                <v-col cols="auto" sm="auto" class="pl-1">
                                                                    {{ csList.job_status }}
                                                                </v-col>
                                                            </v-row>
                                                            <v-row no-gutters class="standard-row" justify="space-between" align="center">
                                                                <v-col cols="auto" sm="auto" class="pr-1">
                                                                    Group Service
                                                                </v-col>
                                                                <v-col cols="auto" sm="auto" class="pl-1">
                                                                    {{ csList.group_service }}
                                                                </v-col>
                                                            </v-row>
                                                            <v-row no-gutters class="standard-row" justify="space-between" align="center">
                                                                <v-col cols="auto" sm="auto" class="pr-1">
                                                                    Service Name
                                                                </v-col>
                                                                <v-col cols="auto" sm="auto" class="pl-1">
                                                                    {{ csList.service_name }}
                                                                </v-col>
                                                            </v-row>
                                                            <v-row no-gutters class="standard-row" justify="space-between" align="center">
                                                                <v-col cols="auto" sm="auto" class="pr-1">
                                                                    QT Vendor
                                                                </v-col>
                                                                <v-col cols="auto" sm="auto" class="pl-1">
                                                                    {{ csList.qt_vendor }}
                                                                </v-col>
                                                            </v-row>
                                                            <v-row no-gutters class="standard-row" justify="space-between" align="center">
                                                                <v-col cols="auto" sm="auto" class="pr-1">
                                                                    QT Value
                                                                </v-col>
                                                                <v-col cols="auto" sm="auto" class="pl-1">
                                                                    {{ csList.qt_value }}
                                                                </v-col>
                                                            </v-row>
                                                            <v-row no-gutters class="standard-row" justify="space-between" align="center">
                                                                <v-col cols="auto" sm="auto" class="pr-1">
                                                                    ส่วนลด
                                                                </v-col>
                                                                <v-col cols="auto" sm="auto" class="pl-1">
                                                                    {{ csList.products.discount }}
                                                                </v-col>
                                                            </v-row>
                                                        </v-row>
                                                    </v-row>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </v-row>
                                </tr>
                            </tbody>
                            <tbody v-else-if="!items.length && !isMobile">
                                <tr v-for="(_, index_tr) in (20 - itemsDataTable.length)" :key="`tr__${index_tr}`" style="height: 35px;">
                                    <td colspan="11">
                                        <v-row
                                            v-if="!index_tr"
                                            no-gutters
                                            class="standard-row font-theme"
                                            align="center"
                                            justify="center"
                                            style="font-size: 12px; font-weight: 500;"
                                        >
                                            ไม่พบข้อมูล
                                        </v-row>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr class="empty-text-table text-center">
                                    ไม่พบข้อมูล
                                </tr>
                            </tbody>
                        </template>
                    </v-data-table>
                </v-row>
            </v-form>
        </v-card>
        <saveBudgetModal />
        <DownloadReportModal />
        <CancelSaveBudgetList />
    </v-container>
</template>

<script>
import { EventBus } from '../EventBus';
import { MainFunction } from '@/functions/mainFunction.js'
import saveBudgetModal from '../components/saveBudgetModal.vue'
import DownloadReportModal from '../components/DownloadReportModal.vue'
import CancelSaveBudgetList from '../components/CancelSaveBudgetList.vue'
export default {
    components: {
        DownloadReportModal,
        saveBudgetModal,
        CancelSaveBudgetList
    },
    data: () => ({
        callApiPending: 0,
        itemsDataTable: [],
        countTransaction: 0,
        trigRowPerPage: false,
        tableHeaders: [
            { text: "No.", align: "center", value: "number", width: "9.71%" },
            { text: 'PO', align: "center", value: 'po', width: "9.65%" },
            { text: 'บันทึกงบ', align: "center", value: 'save_budget', width: "5.88%" },
            { text: 'Sale Document', align: "center", value: 'sale_document', width: "10.51%" },
            { text: 'Document ID', align: "center", value: 'doc_id', width: "8.71%" },
            { text: 'Job Status', align: "center", value: 'job_status', width: "9.69%" },
            { text: 'Group Service', align: "center", value: 'group_service', width: "9.81%" },
            { text: 'Service Name', align: "center", value: 'service_name', width: "20%" },
            { text: 'QT Vendor', align: "center", value: 'qt_vender', width: "6.82%" },
            { text: 'QT Value', align: "center", value: 'qt_value', width: "5.41%" },
            { text: 'ส่วนลด', align: "center", value: 'discount', width: "5.41%" },
            { text: '', align: "center", value: 'delete_button', width: "3.76%" }
        ],
        optionsTransaction: { 
            "page": 1,
            "itemsPerPage": 20
        },
        filterData: { 
            "topic" : {
                "text" : null,
                "value" : null
            },
            "keyword" : null,
            "holdKeyword" : null
        },
        itemSearchDropdown: [
            {
                "text" : "None",
                "value" : ""
            },
            {
                "text" : "Document ID",
                "value" : "cs_document_id"
            },
            {
                "text" : "Sale Document",
                "value" : "sale_document"
            },
            {
                "text" : "Group Service",
                "value" : "group_service"
            },
            {
                "text" : "PO",
                "value" : "po_number"
            },
            {
                "text" : "Document CSPO",
                "value" : "document_cspo"
            },
        ]
    }),
    watch: {
        "optionsTransaction.page"() {
            this.getCSToPO();
            this.trigRowPerPage = true;
        },
        "optionsTransaction.itemsPerPage"() {
            if (!this.trigRowPerPage) {
                this.optionsTransaction.page = 1;
                this.getCSToPO();
            }
        },
        "callApiPending"(val) {
            if (val > 0) {
                EventBus.$emit('loadingState', true);
            } else {
                EventBus.$emit('loadingState', false);
            }
        }
    },
    computed: {
        raDetail() {
            return this.$store.state.raDetail
        },
    },
    mounted() {
        this.getCSToPO()
        EventBus.$on('afterSaveBudget', this.getCSToPO);
        EventBus.$on('afterOpenSaveBudgetListModal', this.getCSToPO);
    },
    beforeDestroy() {
        EventBus.$off('afterSaveBudget');
        EventBus.$off('afterOpenSaveBudgetListModal');
    },
    methods: {
        async getCSToPO() {
            this.callApiPending++;
            this.itemsDataTable = [];
            this.countTransaction = 0;
            $(".data-table.v-data-table > .v-data-table__wrapper").scrollTop(0)
            try {
                const countCSToPO = {
                    baseURL: this.$api_url,
                    url: '/cs_to_po/api/v1/count_all_cs_to_po_search',
                    method: 'GET',
                    params: {
                        "topic": this.filterData.topic?.value || '',
                        "keyword": this.filterData.keyword || ''
                    }
                }
                const searchCSToPO = {
                    baseURL: this.$api_url,
                    url: '/cs_to_po/api/v1/all_cs_to_po_search',
                    method: 'GET',
                    params: {
                        "limit": this.optionsTransaction.itemsPerPage || 20,
                        "offset": (this.optionsTransaction.page - 1) * this.optionsTransaction.itemsPerPage || 0,
                        "topic": this.filterData.topic?.value || '',
                        "keyword": this.filterData.keyword || ''
                    }
                }
                const data = await Promise.all([this.axios(countCSToPO), this.axios(searchCSToPO)]);
                this.countTransaction = +data[0].data?.data[0]?.count || 0;
                this.itemsDataTable = data[1].data.data.map(e => {
                    const accountId = e.account_id || null;
                    const findDate = e.list.find(e1 => e1)?.cs_list[0] || null
                    return {
                        "account_id" : accountId || '',
                        "number" : e?.document_id || '',
                        "transaction_id" : e._id || null,
                        "po" : e?.po_number || '',
                        "save_budget" : e?.save_budget[0]?._id || '',
                        "open_expanded": 1,
                        "start_date" : findDate?.p_so_04 || null,
                        "end_date" : findDate?.p_so_05 || null,
                        "expanded" : e.list.map(e1 => {
                            return {
                                "sale_document" : e1?.so_number || '',
                                "cs_list" : e1?.cs_list.map(e2 => {
                                    return {
                                        "actual" : MainFunction.addComma(+(e2?.actual || '0')),
                                        "revenue" : MainFunction.addComma(+(e2?.revenue || '0')),
                                        "sale_document" : e2?.sale_document || '',
                                        "document_id" : e2?.document_id || '',
                                        "job_status" : e2?.job_status || '',
                                        "group_service" : e2?.group_service || '',
                                        "service_name" : e2?.service_name || '',
                                        "qt_vendor" : e2?.qt_vendor || '',
                                        "qt_value" : e2?.qt_value || '',
                                        "products" : {
                                            "item_id" : '',
                                            "discount" : e2?.discount || '',
                                            "currency_exchange" : "1",
                                            "cut_budget_type" : 'ต้นทุนขาย (COGS)',
                                            "item_name" : e2.service_name,
                                            "total_product_price" : e2.actual || 0,
                                             "qt_value" : e2?.qt_value || '',
                                        }
                                    };
                                })
                            };
                        })
                    };
                });
                this.$nextTick(() => {
                    this.setTemplateTable();
                })
            } catch (error) {
                console.log(error);
            } finally {
                this.callApiPending--;
                this.trigRowPerPage = false;
            }
        },
        confirmFilterData() {
            if (!this.$refs.filterTransactionForm.validate()) {
                return 
            }
            this.filterData.keyword = this.filterData.holdKeyword;
            if (this.filterData.topic.value) {
                if (this.optionsTransaction.page > 1) {
                    return this.optionsTransaction.page = 1;
                } else {
                    this.getCSToPO();
                }
            }
        },
        clearFilterData() {
            if (this.filterData.keyword) {
                this.getCSToPO();
            }
            this.$refs.filterTransactionForm.resetValidation()
            this.$set(this.filterData, 'keyword', '');
            this.$set(this.filterData, 'holdKeyword', '');
            this.$set(this.filterData, 'topic', {
                "text" : null,
                "value" : null
            });
            this.$refs.searchDropdown.blur();
        },
        setTemplateTable() {
            let timer = 0;
            let tableRows = null;
            const interval = setInterval(() => {
                timer += 1;
                tableRows = document.querySelectorAll('.get-element-tr');
                if (timer >= 30) {
                    clearInterval(interval);
                } else if (tableRows) {
                    clearInterval(interval);
                    const buttonElement = document.querySelectorAll('.expand-header-document-id');
                    const cellHideExpandEl = document.querySelectorAll('.hide-expand-icon');
                    const headerRowTable = document.querySelectorAll('.each-header-row-expand-table');
                    for (let i = 0; i < tableRows.length; i++) {
                        const tempHeight = tableRows[i].clientHeight < 40 ? 40 : tableRows[i].clientHeight;
                        buttonElement[i].style.minHeight = `${tempHeight}px`;
                        for (let j = ((i * 5) + 1); j <= ((i * 5) + 5); j++) {
                            cellHideExpandEl[j - 1].style.minHeight = `${tempHeight}px`;
                        }
                        for (let j = ((i * 4) + 1); j <= ((i * 4) + 4); j++) {
                            headerRowTable[j - 1].style.height = `${tempHeight}px`;
                        }
                    }
                }
            }, 100);
        },
        goToDownloadReport() {
            const aboutReport = {
                url : '/report/api/v1/export_report_all_document_cs_to_po',
                from : 'all_document_cs_po'
            }
            EventBus.$emit('openDownloadReportModal', aboutReport);
        },
        openSaveBudget(item) {
            const tempSaveBudget = {
                "type_budget" : "COST",
                "tax_id" : "0107544000094",
                "document_status" : 'W',
                "document_status_permission" : 'W',
                "in_budget" : false,
                "_id" : item._id,
                "start_date" : item.start_date,
                "end_date" : item.end_date,
                "transaction_id" : item.transaction_id,
                "save_budget_id" : item?.save_budget || null,
                "from" : item.number.startsWith('CSPO') ? 'run_po' : (item.number.startsWith('S') && 'save_cs_to_po'),
                "products": item.expanded.flatMap(e =>e.cs_list.map(cs => cs.products)),
                "total_price": MainFunction.addComma(
                    item.expanded.reduce((acc, prev) => {
                        const sumCsList = prev.cs_list.reduce((sum, cs) => {
                            const qt = Number(
                                cs.qt_value?.replace(/,/g, '') || '0'
                            );
                            return sum + (isNaN(qt) ? 0 : qt);
                        }, 0);
                        return acc + sumCsList;
                    }, 0)
                )
            };
            EventBus.$emit('openSaveBudgetModal', tempSaveBudget);
        },
        openCancelSaveBudgetList(data) {
            EventBus.$emit('openSaveBudgetListModal', data);
        },
        handleExpandDocID(index) {
            if ([undefined, null, 1].includes(this.itemsDataTable[index].open_expanded)) {
                return;
            }
            let timer = 0;
            let tableRows = null;
            const interval = setInterval(() => {
                timer += 1;
                tableRows = document.querySelectorAll(`.cell-class-expand-table[name="doc_id_${index}"]`);
                if (timer >= 30) {
                    clearInterval(interval);
                } else if (tableRows.length) {
                    clearInterval(interval);

                    const numRows = tableRows.length / 7;
                    for (let row = 0; row < numRows; row++) {
                        let maximumHeight = 35;
                        for (let col = 0; col < 7; col++) {
                            const value = col * numRows + row;
                            maximumHeight = (maximumHeight < tableRows[value].clientHeight) ? tableRows[value].clientHeight : maximumHeight;
                        }
                        for (let col = 0; col < 7; col++) {
                            const value = col * numRows + row;
                            tableRows[value].style.height = `${maximumHeight}px`;
                        }
                    }
                }
            }, 100);
        }
    }
}
</script>

<style scoped>

    .container {
        padding: 0 4.51%;
        margin: 60px 0;
        color: #000;
        font-family: 'Noto Sans Thai', sans-serif;
    }

    .card-container {
        border-radius: 23px;
        background: #F1F1F1;
        box-shadow: 0px 4px 50px 0px rgba(0, 0, 0, 0.25);
        padding: 15px 18px;
        max-width: 100%;
    }

    .header-container {
        padding: 0 1.458%;
        display: grid;
        grid-template-columns: auto 190px 190px 1fr;
    }

    .header-text {
        font-weight: 400;
        font-size: calc(100% + 0.86vw);
        line-height: 45px;
    }

    .search-input-dropdown {
        margin-left: 27px;
        border-radius: 10px;
        font-size: 14px;
    }

    .list-item-dropdown {
        font-size: 12px;
        font-family: 'Noto Sans Thai', sans-serif;
    }

    .search-input-dropdown >>> .v-input__control > .v-input__slot {
        min-height: auto !important;
        padding: 0 14px;
    }

    .search-input-dropdown >>> .v-input__control > .v-input__slot > .v-select__slot > .v-label {
        top: unset;
    }

    .search-input-dropdown >>> .v-input__control > .v-input__slot > .v-select__slot > .v-input__append-inner {
        margin-top: 0;
    }
    
    .search-input-text {
        margin-left: 15px;
        border-radius: 10px;
        font-size: 14px;
    }

    .search-input-text >>> .v-input__control > .v-input__slot {
        min-height: auto;
        padding: 0 6px 0 17px;
        padding-left: 17px;
    }

    .search-input-text >>> .v-input__control > .v-input__slot > .v-input__append-inner {
        margin: 0;
    }

    .search-input-text >>> .v-input__control > .v-input__slot > .v-input__append-inner > .v-input__icon > .v-icon {
        font-size: 18px;
    }

    .download-button {
        font-weight: 700;
        font-size: 15px;
        justify-self: end;
    }
    
    .data-table {
        width: 100%;
        background-color: #F1F1F1;
        overflow: auto;
    }

    .data-table >>> .v-data-table__wrapper {
        height: calc(100vh - 210px);
        scroll-behavior: smooth;
    }

    .data-table >>> .v-data-table__wrapper > table > thead > tr:last-child > th {
        background-color: #333333;
        height: 38px;
        color: #fff;
        font-size: 13px;
        font-weight: 500;
        padding: 0 5px;
    }

    .data-table >>> .v-data-table__wrapper > table > tbody > tr:nth-child(even),
    .data-table >>> .v-data-table__wrapper > table > tbody > tr:nth-child(even):hover {
        background-color: #FFF !important;
    }

    .data-table >>> .v-data-table__wrapper > table > tbody > tr:nth-child(odd):hover {
        background-color: #F1F1F1 !important;
    }

    .data-table >>> .v-data-table__wrapper > table > tbody > tr > td {
        color: #000;
        font-size: 10px;
        font-weight: 700;
        min-height: 40px !important;
        border-bottom: none !important;
    }

    .data-table >>> .v-data-table__wrapper::-webkit-scrollbar-track {
        border-radius: 10px;
        background-color: transparent !important;
    }

    .data-table >>> .v-data-table__wrapper::-webkit-scrollbar {
        width: 8px;
        height: 8px;
        background-color: transparent !important;
    }

    .data-table >>> .v-data-table__wrapper::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: #d6d6d6;
    }

    .data-table >>> .v-data-table__wrapper > table > tbody > tr > td {
        min-height: 30px !important;
    }

    .expansion-cs-list >>> .v-expansion-panel {
        background-color: transparent;
    }

    .expansion-cs-list >>> .v-expansion-panel::before {
        box-shadow: none;
    }

    .expansion-cs-list >>> .v-expansion-panel > button > .v-expansion-panel-header__icon {
        margin: 0 auto;
    }

    .expansion-cs-list >>> .v-expansion-panel > button {
        min-height: 40px;
    }

    .expansion-cs-list >>> .v-expansion-panel > .v-expansion-panel-content > .v-expansion-panel-content__wrap {
        padding: 12px 0 0 0;
    }

    .hide-expand-icon {
        visibility: hidden;
    }
    
    .cell-class-expand-table {
        font-weight: 400;
        padding-bottom: 8px;
        min-height: 35px;
    }

    .close-expand-icon {
        font-size: 10px;
        pointer-events: none;
    }

    .close-expand-icon >>> .v-expansion-panel-header__icon {
        display: none;
    }

    .empty-text-table {
        font-size: 18px !important;
        font-weight: 700;
    }

    .table-row-mobile {
        padding: 8px;
        font-size: 10px;
        font-weight: 700;
        line-height: 28px;
    }

    .expand-table-mobile >>> .v-expansion-panel {
        background-color: transparent;
    }
    
    .expand-table-mobile >>> .v-expansion-panel::before {
        box-shadow: none;
    }

    .expand-table-mobile >>> .v-expansion-panel > .v-expansion-panel-header {
        padding: 0;
        font-size: 10px;
        font-weight: 700;
        line-height: 30px;
        min-height: auto;
    }

    .expand-table-mobile >>> .v-expansion-panel > .v-expansion-panel-content > .v-expansion-panel-content__wrap {
        padding: 0;
        font-weight: 500;
    }

    .each-header-row-expand-table {
        min-height: 40px !important;
        height: auto;
        line-height: 24px;
    }

    @media only screen and (max-width: 75em) {

        .data-table >>> .v-data-table__wrapper > table > thead > tr > th:nth-child(1),
        .data-table >>> .v-data-table__wrapper > table > thead > tr > th:nth-child(2) {
            min-width: 100px !important;
        }

        .data-table >>> .v-data-table__wrapper > table > thead > tr > th:nth-child(3),
        .data-table >>> .v-data-table__wrapper > table > thead > tr > th:nth-child(11) {
            min-width: fit-content !important;
        }

        .data-table >>> .v-data-table__wrapper > table > thead > tr > th:nth-child(4) {
            min-width: 150px !important;
        }

        .data-table >>> .v-data-table__wrapper > table > thead > tr > th:nth-child(5),
        .data-table >>> .v-data-table__wrapper > table > thead > tr > th:nth-child(9),
        .data-table >>> .v-data-table__wrapper > table > thead > tr > th:nth-child(10) {
            min-width: 110px !important;
        }

        .data-table >>> .v-data-table__wrapper > table > thead > tr > th:nth-child(6) {
            min-width: 78px !important;
        }

        .data-table >>> .v-data-table__wrapper > table > thead > tr > th:nth-child(7) {
            min-width: 120px !important;
        }

        .data-table >>> .v-data-table__wrapper > table > thead > tr > th:nth-child(8) {
            min-width: 270px !important;
        }
    }

    @media only screen and (max-width: 60em) {

        .header-container {
            grid-template-columns: 1fr 1fr !important;
            gap: 20px;
        }

        .header-text {
            grid-column: 1 / 2;
        }

        .search-input-dropdown, .search-input-text {
            margin-left: unset;
        }

        .download-button {
            grid-column: 2 / -1;
            grid-row: 1;
        }
    }

    @media only screen and (max-width: 37.5em) {

        .data-table >>> .v-data-table__wrapper {
            height: calc(100vh - 342px);
        }
    }

    @media only screen and (max-width: 30.56em) {

        .data-table >>> .v-data-table__wrapper {
            height: calc(100vh - 360px);
        }
    }
</style>
